import { tv } from "../../../variants/tv.js";
const moduleTestimonialsVariants = tv({
    slots: {
        gridWrapper: '@container w-full',
        grid: '@xl:gap-y-8 @5xl:gap-x-8 grid w-full gap-x-4 gap-y-6'
    },
    variants: {
        columns: {
            1: {
                grid: 'grid-cols-1'
            },
            2: {
                grid: '@xl:grid-cols-2 grid-cols-1'
            },
            3: {
                grid: '@5xl:grid-cols-3 @lg:grid-cols-2 grid-cols-1'
            }
        },
        display: {
            simple: {},
            simpleCenter: {},
            simpleSplit: {}
        }
    },
    compoundVariants: [
        {
            columns: 1,
            display: [
                'simple',
                'simpleCenter'
            ],
            class: {
                gridWrapper: '@2xl:max-w-1/2 @2xl:mx-auto'
            }
        },
        {
            columns: 2,
            display: [
                'simple',
                'simpleCenter'
            ],
            class: {
                gridWrapper: '@2xl:max-w-2/3 @2xl:mx-auto'
            }
        }
    ],
    defaultVariants: {
        columns: 3
    }
});
export { moduleTestimonialsVariants };
